import { Map, List, fromJS } from 'immutable'
import _get from 'lodash/get'
import {
  GET_MERCHANDISING_CAMPAIGNS_DATA,
  SET_MERCHANDISING_CAMPAIGNS_DATA,
  SET_MERCHANDISING_CAMPAIGNS_ERROR,
  DOWNLOAD_MERCHANDISING_CAMPAIGNS_ERROR,
  CREATE_MERCHANDISING_CAMPAIGN_SUCCESS,
  CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_SUCCESS,
  CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_FAILURE,
  UPDATE_MERCHANDISING_CAMPAIGN,
  UPDATE_MERCHANDISING_CAMPAIGN_SUCCESS,
  DELETE_MERCHANDISING_CAMPAIGN_SUCCESS,
  SET_CREATING_CAMPAIGN,
  CREATE_CAMPAIGN_CONTENT,
  CREATE_CAMPAIGN_CONTENT_SUCCESS,
  CREATE_CAMPAIGN_CONTENT_FAILURE,
  UPDATE_CAMPAIGN_CONTENT,
  UPDATE_CAMPAIGN_CONTENT_SUCCESS,
  UPDATE_CAMPAIGN_CONTENT_FAILURE,
  CREATE_MERCHANDISING_CAMPAIGN_FAILURE,
  UPDATE_MERCHANDISING_CAMPAIGN_FAILURE,
  SET_HAS_PREVIEW_MEDIA,
  SET_ONBOARD_CHOICES,
} from './actions'

export const initialState = Map()

const findCampaignToUpdate = (campaignData, idToFind) => campaignData.get(idToFind)

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case GET_MERCHANDISING_CAMPAIGNS_DATA:
      return state.set('processing', true)
    case SET_MERCHANDISING_CAMPAIGNS_DATA:
      return state
        .set('data', _get(payload, 'data', Map()))
        .set('page', _get(payload, 'page'))
        .set('perPage', _get(payload, 'perPage'))
        .set('totalCount', _get(payload, 'totalCount'))
        .set('processing', false)
    case DOWNLOAD_MERCHANDISING_CAMPAIGNS_ERROR:
    case SET_MERCHANDISING_CAMPAIGNS_ERROR:
      return state.set('error', payload.error).set('processing', false)
    case SET_CREATING_CAMPAIGN:
      return state.set('creatingCampaign', payload) // payload will be true/false
    case CREATE_MERCHANDISING_CAMPAIGN_SUCCESS:
      return state
        .update('data', (campaignData) => {
          // using this to keep campaign form in edit mode
          const newCampaign = payload.set('isNewlyCreatedCampaign', true)
          const campaignId = parseInt(payload.get('id'), 10)
          return campaignData.set(campaignId, newCampaign)
        })
        .set('creatingCampaign', false)
        .remove('createCampaignWithServerError')
    case CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_SUCCESS:
      return state.set('creatingCampaign', false).remove('createCampaignWithServerError')
    case CREATE_MERCHANDISING_CAMPAIGN_FAILURE:
      // eslint-disable-next-line
      const campaignWithErrors = payload.campaign.set('errors', payload.errorsParsed)
      return state.set('createCampaignWithServerError', campaignWithErrors)
    case CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_FAILURE:
      // eslint-disable-next-line
      const campaignWithContentErrors = action.campaign.set('errors', action.error)
      return state.set('createCampaignWithServerError', campaignWithContentErrors)
    case UPDATE_MERCHANDISING_CAMPAIGN:
      // add specific campaign processing that will be blown out by update success/failure
      return state.update('data', (campaignData) =>
        campaignData.set(payload.data.get('id'), payload.data.set('processing', true)),
      )
    case UPDATE_MERCHANDISING_CAMPAIGN_SUCCESS:
      return state.update('data', (campaignData) => {
        const campaignToUpdate = findCampaignToUpdate(campaignData, payload.get('id'))
        const updatedCampaign = campaignToUpdate
          .set('isNewlyUpdatedCampaign', true)
          .set('processing', false)
        return campaignData.set(payload.get('id'), updatedCampaign)
      })
    case UPDATE_MERCHANDISING_CAMPAIGN_FAILURE:
      return state.update('data', (campaignData) => {
        const campaignToUpdate = findCampaignToUpdate(campaignData, payload.campaign.get('id'))
        // add specific campaign processing that will be blown out by update success/failure
        return campaignData.set(
          payload.campaign.get('id'),
          campaignToUpdate.set('errors', payload.errorsParsed),
        )
      })
    case DELETE_MERCHANDISING_CAMPAIGN_SUCCESS:
      return state.update('data', (campaignData) => campaignData.delete(payload.campaignId))
    case CREATE_CAMPAIGN_CONTENT:
    case UPDATE_CAMPAIGN_CONTENT:
      return state.update('data', (campaignData) => {
        const campaignToUpdate = findCampaignToUpdate(campaignData, payload.get('campaignId'))
        const updatedCampaign = campaignToUpdate
          .set('processing', true)
          .remove('isNewlyCreatedCampaign')
          .remove('isNewlyUpdatedCampaign')
        return campaignData.set(payload.get('campaignId'), updatedCampaign)
      })
    case UPDATE_CAMPAIGN_CONTENT_SUCCESS:
    case CREATE_CAMPAIGN_CONTENT_SUCCESS:
      return state
        .update('data', (campaignData) => {
          const campaignToUpdate = findCampaignToUpdate(campaignData, payload.get('campaignId'))
          const updatedCampaign = campaignToUpdate
            .set('processing', false)
            .set('contentItems', List().push(payload)) // only ever have one contentItem now
            .set('isNewlyUpdatedCampaign', true)
            .remove('isNewlyCreatedCampaign')

          return campaignData.set(payload.get('campaignId'), updatedCampaign)
        })
        .removeIn(['contentErrors', payload.get('campaignId')])
    case UPDATE_CAMPAIGN_CONTENT_FAILURE:
    case CREATE_CAMPAIGN_CONTENT_FAILURE:
      return state
        .update('data', (campaignData) => {
          const campaignToUpdate = findCampaignToUpdate(campaignData, _get(action, 'campaignId'))
          const updatedCampaign = campaignToUpdate
            .set('processing', false)
            .remove('isNewlyCreatedCampaign')
            .remove('isNewlyUpdatedCampaign')
          return campaignData.set(payload.get('campaignId'), updatedCampaign)
        })
        .setIn(['contentErrors', _get(action, 'campaignId')], fromJS(_get(action, 'error')))
    case SET_HAS_PREVIEW_MEDIA:
      return state.update('data', (campaignData) => {
        const campaignToUpdate = findCampaignToUpdate(campaignData, payload.campaignId)
        const updatedCampaign = campaignToUpdate.set('hasPreviewMedia', payload.hasPreviewMedia)
        return campaignData.set(payload.campaignId, updatedCampaign)
      })
    case SET_ONBOARD_CHOICES:
      return state.set('onboardChoices', _get(payload, 'onboardChoices'))
    default:
      return state
  }
}
